import { __toESM } from "./chunk-fHKeL6sp.mjs";
import { require_function } from "./function-BaRNSZzx.mjs";
import { require_Either } from "./Either-BhWbxPBW.mjs";

//#region src/safeParse.ts
var import_Either = /* @__PURE__ */ __toESM(require_Either());
var import_function = /* @__PURE__ */ __toESM(require_function());
/**
* Combines Zod's `safeParse` with Either.
*
* @category Zod
* @example
* ```ts twoslash
* import { z, safeParse } from '@simplisafe/ewok'
*
* const schema = z.string()
*
* const result = safeParse('hello', schema) // => Right('hello')
* ```
*/
const safeParse = (data, schema, params) => {
	return (0, import_function.pipe)(schema.safeParse(data, params), (x) => x.success ? import_Either.right(x.data) : import_Either.left(x.error));
};

//#endregion
export { safeParse };
//# sourceMappingURL=safeParse-BlFrdSri.mjs.map